import { render, staticRenderFns } from "./MenuLinks.vue?vue&type=template&id=7ff03283&scoped=true"
import script from "./MenuLinks.vue?vue&type=script&lang=js"
export * from "./MenuLinks.vue?vue&type=script&lang=js"
import style0 from "./MenuLinks.vue?vue&type=style&index=0&id=7ff03283&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff03283",
  null
  
)

export default component.exports